import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import useCheckedItems from '@functional/useCheckedItems';

import SaveButton from '@ui-elements/SaveButton';
import BasicModal from '@ui-parts/BasicModal';
import SpecialPanelChoicesCheckBoxes from '@ui-parts/SpecialPanelChoicesCheckBoxes';

const BodyWrapper = styled.div`
  padding: 0 15px;
  display: flex;
  justify-content: center;
`;

const TWO_COL_QUESTION_KEYS = ['industry', 'householdIncome', 'marriageStatus', 'childrenStatus'];

function SpecialPanelModal({
  open,
  handleClose,
  specialPanelDisplaySettingId,
  questionKey,
  checkedChoices,
}) {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const [
    checkedItems,
    { setCheckedItems, checkAll, uncheckAll, checkTargetItem, uncheckTargetItem },
  ] = useCheckedItems(checkedChoices);

  const handleChange = (e, choiceId) => {
    // when checked
    if (e.target.checked) {
      return choiceId === 'isAllChecked' ? checkAll() : checkTargetItem(choiceId);
    }

    // when unchecked
    return choiceId === 'isAllChecked' ? uncheckAll() : uncheckTargetItem(choiceId);
  };

  return (
    <BasicModal
      open={open}
      titleProps={{
        titleLabel: t('quotas.deliveryTarget'),
        title: t(`quotas.modals.${questionKey}.title`),
        desc: t(`quotas.modals.${questionKey}.desc`),
        note: t(`quotas.modals.${questionKey}.note`),
      }}
      handleClose={() => {
        handleClose();
        // 選択状態を元に戻してあげる
        setCheckedItems(checkedChoices);
      }}
      buttons={[
        <SaveButton
          key="button1"
          sx={{ width: 148 }}
          handleClick={() => {
            dispatch({
              type: 'qualifications/changedSpecialPanelCheckedItems',
              payload: {
                key: questionKey,
                value: checkedItems,
                specialPanelDisplaySettingId,
              },
            });
            handleClose();
          }}
          label={t('appCommon.setting')}
        />,
      ]}
      dataTestId={`SpecialPanelModal-${questionKey}`}
    >
      <BodyWrapper>
        {!!checkedChoices && (
          <SpecialPanelChoicesCheckBoxes
            choices={checkedItems}
            handleChange={handleChange}
            specialPanelDisplaySettingId={specialPanelDisplaySettingId}
            twoCol={TWO_COL_QUESTION_KEYS.includes(questionKey)}
          />
        )}
      </BodyWrapper>
    </BasicModal>
  );
}

SpecialPanelModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  specialPanelDisplaySettingId: PropTypes.number.isRequired,
  questionKey: PropTypes.string.isRequired,
  // ↓i動的なのでいったんlintエラーは無視してarrayで定義
  // eslint-disable-next-line react/forbid-prop-types
  checkedChoices: PropTypes.object.isRequired,
};

export default SpecialPanelModal;
